import { DEPARTMENT_LABEL } from '@hub/shared';

/**
 * Prevod identifikatoru na ceske texty. Identifikatory v kodu a databazi jsou
 * anglicky, texty administrace cesky (CLAUDE.md konvence, DECISIONS D-23).
 */

export const SEND_MODE_LABEL: Record<string, string> = {
  dry_run: 'Nanečisto',
  test_allowlist: 'Testovací adresy',
  live: 'Ostrý',
};

export const ROLE_LABEL: Record<string, string> = { ...DEPARTMENT_LABEL };

/** Popisky položek pracovní fronty „Můj přehled“ (u kind „exception“ se použije EXCEPTION_LABEL, u „reason“ REASON_LABEL). */
export const QUEUE_KIND_LABEL: Record<string, string> = {
  review_batch: 'Dávka hodnocení čeká na rozhodnutí',
};

export const TRIP_STATE_LABEL: Record<string, string> = {
  scheduled: 'Naplánovaná',
  awaiting_date: 'Čeká na termín',
  tickets_pending: 'Vstupenky se chystají',
  ready: 'Vstupenky doručené',
  race_week: 'Týden závodu',
  post_race: 'Po závodě',
  closed: 'Ukončená',
};

export const DATE_STATUS_LABEL: Record<string, string> = {
  unknown: 'Neznámý',
  provisional: 'Předběžný',
  confirmed: 'Potvrzený',
  cancelled: 'Zrušený',
};

export const SALES_STATUS_LABEL: Record<string, string> = {
  not_started: 'Prodej nezahájen',
  open: 'V prodeji',
  limited: 'Poslední místa',
  sold_out: 'Vyprodáno',
  closed: 'Prodej ukončen',
};

export const TICKET_STATUS_LABEL: Record<string, string> = {
  pending: 'Čeká na přidělení',
  allocated: 'Přiřazené',
  issued: 'Vystavené',
  dispatched: 'Odeslané',
  delivered: 'Doručené',
};

export const OUTCOME_LABEL: Record<string, string> = {
  sent: 'Odesláno',
  held: 'Drženo',
  deferred: 'Odloženo',
  suppressed: 'Potlačeno',
  merged: 'Sloučeno',
  expired: 'Propadlo',
};

/** Důvody z `decisions` — vysvětlení, proč zpráva neodešla. */
export const REASON_LABEL: Record<string, string> = {
  care_hold: 'Zákazník je označen péčí (zpráva se drží)',
  provider_blacklisted: 'Adresa je blokovaná u SmartEmailingu',
  provider_unsubscribed: 'Odhlášen ve SmartEmailingu (marketing se neposílá)',
  no_brand: 'Zpráva nemá určenou značku',
  unknown_brand: 'Značka zprávy neexistuje',
  brand_switch_off: 'Odesílání značky je vypnuto',
  template_not_synced: 'Šablona není nahraná do SmartEmailingu',
  missing_replace: 'Šabloně chybí hodnota proměnné',
  replace_too_large: 'Hodnota proměnné je větší než 64 kB',
  provider_marketing_unsupported: 'Provider neumí marketing přes šablonu',
  switch_off: 'vypínač „smí odejít“ je vypnutý',
  trip_closed: 'cesta je ukončená',
  hard_bounce: 'adresa je trvale nedoručitelná',
  no_consent: 'chybí marketingový souhlas',
  holdout: 'kontakt je v kontrolní skupině',
  race_window: 'kontakt je v okně závodu',
  support_contact: 'kontakt se ozval podpoře',
  frequency_cap: 'frekvenční limit',
  template_missing: 'chybí mapování šablony',
  not_in_allowlist: 'adresa není v povoleném seznamu',
  outside_window: 'mimo časové okno příjemce',
  stale: 'mezitím se změnil termín',
  superseded: 'přebila novější verze termínu',
  tickets_not_delivered: 'vstupenky už jsou doručené',
  race_pack_ready: 'race pack ještě není připravený',
  trip_not_told_date: 'cesta už termín zná',
  trip_told_date: 'cesta termín neznala',
  guide_only_still: 'kontakt už vstupenku má',
  gift_recipient_set: 'dárek ještě nemá obdarovaného',
  gift_for_someone_else: 'dárek je pro kupujícího',
  gift_not_redeemed: 'dárek je už uplatněný',
  no_activity_90d: 'kontakt je aktivní',
  no_flexi: 'cesta už Flexi má',
  flexi_buy_open: 'okno pro nákup Flexi je zavřené',
  nearest_trip: 'není to nejbližší cesta',
  upgrade_available: 'není dostupný dražší upgrade',
  review_not_held: 'dávka hodnocení je pozdržená',
  review_approved: 'dávka hodnocení není schválená',
  not_excluded_from_review: 'objednávka je z hodnocení vyřazená',
  no_trip_for_next_race: 'kontakt už má cestu na další ročník',
  watchdog_unconfirmed: 'sledování je už potvrzené, zrušené nebo vypršelo',
  watchdog_confirmed: 'sledování není potvrzené (nebo je zrušené či vypršelo)',
  offer_still_available: 'nabídka už není dostupná',
  watchdog_not_converted: 'zákazník už nakoupil',
  submission_first: 'potvrzení posílá první záznam téhož odeslání (tohle je v něm sloučené)',
  submission_settled: 'čeká se na ostatní záznamy téhož odeslání formuláře',
  watchdog_urls_ready: 'značka nemá nastavený odkaz na stránku e-shopu',
  scope_missing: 'objekt pravidla zmizel',
  unknown_code: 'kód není v katalogu',
  no_recipient: 'chybí adresa příjemce',
  expired: 'propadlo bez rozhodnutí',
  already_reserved: 'zprávu zarezervoval jiný běh',
  no_contact: 'adresa nemá v hubu kontakt',
  layer_disabled: 'vrstva Marketingové odesílání je vypnutá',
  missing_unsubscribe: 'šablona nemá odkaz na odhlášení',
  missing_preheader: 'šablona nemá text za předmětem (preheader)',
  duplicate_contact: 'stejný kontakt už v rozesílce je pod jinou adresou',
  send_error: 'odeslání selhalo (zpráva se znovu neposílá)',
  verified_sent: 'správce ověřil, že zpráva odešla',
  deadline: 'propadlo po lhůtě rozesílky',
  condition: 'podmínka pravidla',
  merged: 'sloučeno do jiné zprávy',
  sent: 'odesláno',
};

export const MESSAGE_STATUS_LABEL: Record<string, string> = {
  reserved: 'Rezervováno',
  handed_to_provider: 'Předáno',
  sent: 'Odesláno',
  delivered: 'Doručeno',
  bounced: 'Nedoručeno',
  failed: 'Chyba',
  unknown: 'Neznámý stav',
  dry_run: 'Nanečisto',
  logged: 'Zalogováno (e-shop)',
};

export const EXCEPTION_LABEL: Record<string, string> = {
  care_suggestion: 'Návrh označení zákazníka čeká',
  job_failing: 'Úloha opakovaně selhává',
  worker_silent: 'Worker neodpovídá',
  job_stuck: 'Úloha visela a byla přerušena',
  hard_bounce_pending_tickets: 'Nedoručitelná adresa u cesty s nedoručenými vstupenkami',
  date_missing: 'Závod se blíží bez potvrzeného termínu',
  promise_missed: 'Uplynulý slib doručení',
  race_pack_missing: 'Race pack nepřipravený v T−10',
  review_pending: 'Dávka hodnocení čeká',
  guide_only_unresolved: '„Jen průvodce“ bez reakce',
  gift_unredeemed: 'Neuplatněný dárek',
  provider_unconfirmed: 'Marketing nepotvrzený providerem do 2 h',
  sync_error: 'Chyba synchronizace',
  send_failed: 'Odeslání selhalo',
  message_unknown: 'Zpráva v neznámém stavu',
  tx_failure_rate: 'Transakční zprávy z e-shopu selhávají',
  tx_duplicate_sender: 'Zákazník dostal transakční e-mail dvakrát (hub i e-shop)',
  tx_no_calls: 'E-shop přestal volat transakční API',
  no_delivery_confirmation: 'Odeslané zprávy bez potvrzení doručení',
};

export const REVIEW_STATUS_LABEL: Record<string, string> = {
  pending: 'Čeká na rozhodnutí',
  approved: 'Schváleno',
  held: 'Pozdrženo',
  skipped: 'Přeskočeno',
  not_required: 'Bez hodnocení',
};

export const CLOSED_REASON_LABEL: Record<string, string> = {
  race_cancelled: 'závod zrušen',
  moved: 'přesunuto na jiný závod',
  refunded: 'vráceno',
  cancelled: 'stornováno',
  canceled: 'stornováno',
  storno: 'stornováno',
  ended: 'více než 30 dní po závodě',
  no_active_items: 'žádná aktivní položka',
};

export const CHANNEL_LABEL: Record<string, string> = {
  service: 'Servis',
  marketing: 'Marketing',
};

export const SENDER_LABEL: Record<string, string> = {
  hub: 'Hub',
  eshop: 'E-shop',
};

export const WINDOW_LABEL: Record<string, string> = {
  standard: 'Standardní (9–11)',
  critical: 'Důležité (8–20)',
  immediate: 'Kdykoli',
};

export const TIMELINE_LABEL: Record<string, string> = {
  order: 'Objednávka',
  message: 'Zpráva',
  decision: 'Neodeslaná zpráva',
  web_event: 'Web',
  support: 'Podpora',
  domain_event: 'Událost',
  reaction: 'Reakce na zprávu',
  signal: 'Signál',
  content_read: 'Čtení článku',
  app_event: 'Aplikace',
};

export const REACTION_LABEL: Record<string, string> = {
  delivered: 'Doručeno',
  sent: 'Odesláno',
  opened: 'Otevřeno',
  clicked: 'Proklik',
  bounced: 'Odskočeno',
  unsubscribed: 'Odhlášení',
  complained: 'Stížnost',
};

/** Transakční zprávy z e-shopu (obrazovka Transakční zprávy). */
export const TX_STATUS_LABEL: Record<string, string> = {
  queued: 'Ve frontě',
  sending: 'Odesílá se',
  sent: 'Odesláno',
  held: 'Zadrženo',
  shadow: 'Stín (neodesláno)',
  dry_run: 'Nanečisto',
  failed: 'Chyba',
  unknown: 'Neznámý výsledek',
  cancelled: 'Zrušeno',
};

export const TX_MODE_LABEL: Record<string, string> = {
  off: 'Vypnuto',
  shadow: 'Stín',
  live: 'Ostré',
};

export const TX_REASON_LABEL: Record<string, string> = {
  not_in_allowlist: 'Adresa není v seznamu zkušebních adres',
  sending_not_allowed: 'Vypnutý přepínač „smí odejít“',
  brand_sending_disabled: 'Značce je odesílání vypnuté',
  template_missing: 'Chybí publikovaná šablona',
  missing_variables: 'Šabloně chybí údaje',
  hard_bounce: 'Adresa dříve selhala natvrdo',
  provider_blacklisted: 'Adresa je blokovaná u SmartEmailingu',
  expired: 'Prošla platnost',
  provider_not_configured: 'Nejsou přístupy ke SmartEmailingu',
  provider_html_unsupported: 'Provider neumí odeslat HTML',
  shadow: 'Stínový režim',
  dry_run: 'Režim nanečisto',
  code_not_enabled: 'Kód není zapnutý',
  unknown_brand: 'Značka neexistuje',
  already_sent_by_journey: 'Potvrzení už poslala cesta zákazníka',
  send_failed: 'Odeslání selhalo',
  cancelled_by_admin: 'Zrušeno v administraci',
  provider_rejected: 'SmartEmailing zprávu odmítl',
  provider_unknown: 'Výsledek předání SmartEmailingu není znám',
  provider_rate_limited: 'SmartEmailing zpomaluje, hub zkusí znovu',
  order_state_changed: 'Objednávka se mezitím změnila (zaplacena nebo zrušena)',
  payload_missing: 'Chybí uložený obsah zprávy',
  sender_not_allowed: 'Odesílatel není povolený',
  provider_guard: 'Pojistka zabránila odeslání',
  provider_templated_unsupported: 'Provider neumí šablonu e-shopu',
  layer_disabled: 'Vlna nasazení je vypnutá',
};

/** Kroky časové osy jedné transakční zprávy. */
export const TX_TIMELINE_LABEL: Record<string, string> = {
  received: 'Přijato od e-shopu',
  queued: 'Zařazeno do fronty',
  processing: 'Zpracování zahájeno',
  handed: 'Předáno SmartEmailingu',
  delivered: 'Doručeno',
  opened: 'Otevřeno',
  clicked: 'Kliknuto na odkaz',
  bounced: 'Odskočilo',
  complained: 'Stížnost příjemce',
};

export const TX_TIMELINE_STATE_LABEL: Record<string, string> = {
  done: 'hotovo',
  pending: 'čeká se',
  failed: 'problém',
  skipped: 'neproběhne',
};

export const COMMUNICATION_KIND_LABEL: Record<string, string> = {
  journey: 'Cesty a marketing',
  transactional: 'Transakční zprávy z e-shopu',
  eshop: 'Odeslal e-shop',
  imported: 'Import ze SmartEmailingu',
  support: 'Podpora',
  reaction: 'Reakce',
};

export const TX_CHECK_LABEL: Record<string, string> = {
  shadow_days: 'Dost dlouhý stín',
  shadow_volume: 'Dost zpráv ve stínu',
  parity: 'Shoda se zprávami e-shopu',
  no_validation_errors: 'Žádná neplatná data od e-shopu',
  template_published: 'Publikovaná šablona v každém jazyce',
  switch_on: 'Zapnutý přepínač „smí odejít“',
  provider_ready: 'Skutečný provider a režim odesílání',
  samples_approved: 'Ukázky schváleny člověkem',
};

export const TX_PARITY_LABEL: Record<string, string> = {
  matched: 'Shoda',
  only_shop: 'Jen e-shop',
  only_hub: 'Jen hub',
  both: 'Poslalo obojí (dvojí e-mail)',
};

export const label = (map: Record<string, string>, key: string | null | undefined): string =>
  key === null || key === undefined ? '—' : (map[key] ?? key);

export const CARE_KIND_LABEL: Record<string, string> = {
  problem: 'Měl problém',
  complaint: 'Stížnost',
  do_not_contact_race: 'Nekontaktovat k závodu',
  vip: 'VIP (jen upozornění)',
};
export const SATISFACTION_LABEL: Record<string, string> = {
  satisfied: 'Spokojený',
  neutral: 'Neutrální',
  dissatisfied: 'Nespokojený',
  unknown: 'Neznámé',
};
export const CASE_CHANNEL_LABEL: Record<string, string> = {
  email: 'E-mail',
  phone: 'Telefon',
  chat: 'Chat',
  social: 'Sociální sítě',
  shop: 'E-shop',
  other: 'Jiné',
};
export const SUGGESTION_REASON_LABEL: Record<string, string> = {
  dissatisfied_case: 'Nespokojený zákazník',
  support_near_race: 'Dotaz podpoře těsně u závodu',
};
export const IMPORT_RESULT_LABEL: Record<string, string> = {
  ok: 'v pořádku',
  invalid: 'neplatný řádek',
  unknown: 'zákazník nenalezen',
  brand_required: 'chybí značka',
  brand_restricted: 'značka mimo váš účet',
  no_trip_for_race: 'bez cesty na tento závod',
  no_consent: 'bez souhlasu',
  care_flag: 'označen péčí',
  duplicate: 'duplicita',
  already_included: 'už vybrán',
};

/** Otevření: člověkem (stolní/mobilní zařízení), nebo automaticky (ochrana soukromí poštovní služby, skener). */
export const OPEN_HUMAN_LABEL = 'otevřeno (člověk)';
export const OPEN_AUTO_LABEL = 'otevřeno (automaticky)';
export const OPEN_HINT =
  'Automatické otevření dělá poštovní služba nebo ochrana soukromí (např. Apple Mail), ne nutně člověk; člověk = otevřeno na počítači nebo mobilu.';

/** Poslední stažení reakcí ze SmartEmailingu (`GET /api/send-tests/status`, Přehled → zdraví). */
export interface ReactionsPoll {
  at: string;
  read: number | null;
  stored: number | null;
  duplicates: number | null;
  unmatched: number | null;
  error: string | null;
}

export const ENVIRONMENT_LABEL: Record<string, string> = {
  development: 'Vývoj',
  staging: 'Zkouška (staging)',
  production: 'Produkce',
};

/** Rozesílky (vlna 1, docs/ROZESILKY.md). */
export const BROADCAST_STATUS_LABEL: Record<string, string> = {
  draft: 'Koncept',
  preview: 'Náhled hotový',
  tested: 'Zkušebně odesláno',
  approved: 'Schváleno',
  scheduled: 'Naplánováno',
  sending: 'Odesílá se',
  awaiting_step: 'Čeká na potvrzení kroku',
  completed: 'Dokončeno',
  aborted: 'Přerušeno',
};

export const BROADCAST_STATUS_TONE: Record<string, 'ok' | 'warn' | 'bad' | 'neu' | 'acc'> = {
  draft: 'neu',
  preview: 'neu',
  tested: 'acc',
  approved: 'acc',
  scheduled: 'acc',
  sending: 'warn',
  awaiting_step: 'warn',
  completed: 'ok',
  aborted: 'bad',
};

/** Plán rozesílek (D-287). */
export const PLAN_STATUS_LABEL: Record<string, string> = {
  planned: 'Plánováno',
  in_preparation: 'V přípravě',
  ready: 'Připraveno',
  scheduled: 'Naplánováno',
  sent: 'Odesláno',
  cancelled: 'Zrušeno',
};
export const PLAN_STATUS_TONE: Record<string, 'ok' | 'warn' | 'bad' | 'neu' | 'acc'> = {
  planned: 'neu',
  in_preparation: 'warn',
  ready: 'acc',
  scheduled: 'acc',
  sent: 'ok',
  cancelled: 'neu',
};
export const PLAN_KIND_LABEL: Record<string, string> = {
  main_sale: 'Hlavní prodejní',
  reminder_availability: 'Reminder dle dostupnosti',
  reminder_no_purchase: 'Reminder pro zájemce bez nákupu',
  other: 'Jiná',
};
export const PLAN_RACE_MATCH_LABEL: Record<string, string> = {
  matched: 'Nalezen v kalendáři',
  manual: 'Přiřazeno ručně',
  ambiguous: 'Více shod, vyberte ručně',
  not_found: 'Není v kalendáři, přiřaďte ručně',
};

export const RECIPIENT_STATUS_LABEL: Record<string, string> = {
  pending: 'Dostane zprávu',
  sent: 'Odesláno',
  held: 'Zadrženo (zkusí se znovu)',
  suppressed: 'Nedostane (konečné)',
  failed: 'Odeslání selhalo',
  expired: 'Propadlo',
};

export const WINDOW_MODE_LABEL: Record<string, string> = {
  recipient_window: 'V okně značky podle pásma příjemce',
  asap: 'Co nejdřív (kdykoli)',
};

export const CANARY_STEPS_LABEL = ['1 %', '10 %', '100 %'];
